import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './App.scss';
import './global-theme.css'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Join from './pages/JoinPage/Join';
import WorkspaceProvider from './features/workspace/WorkspaceProvider';
import CreateRoom from './pages/CreateRoom/CreateRoom';
import Home from './pages/Home/Home';
import Kicked from './pages/Kicked/Kicked';
import Disconnected from './pages/Disconnected/Disconnected';
import YourRooms from './pages/YourRooms/YourRooms';
import Terms from './pages/Terms/Terms';
import Privacy from './pages/Privacy/Privacy';
import About from './pages/About/About';
import AboutCreator from './pages/AboutCreator/AboutCreator';
import ComingSoon from './pages/ComingSoon/ComingSoon';
import GettingStarted from './pages/HowTo/GettingStarted';
import Deleted from './pages/Deleted/Deleted';
import Login from './pages/Login/Login';
import DownloadHelp from './pages/DownloadHelp/DownloadHelp';
import RoomFull from './pages/RoomFull/RoomFull';
import { UserProvider } from './context/UserContext/UserContext';
import AuthToast from './components/AuthToast/AuthToast';
import TransferNotifications from './shared/components/TransferNotifications/TransferNotifications';
import AccountContinuePrompt from './components/AccountContinuePrompt/AccountContinuePrompt';



declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export function AnalyticsListener() {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;

    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  return null;
}


function App() {


  return (
    <UserProvider>
      <Router>
        <AnalyticsListener />
        <div className="App">
          <AuthToast />
          <AccountContinuePrompt />
          <TransferNotifications />
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/join' element={<Join />} />
            <Route path='/room/:roomId' element={<WorkspaceProvider />} />
            <Route path='/createroom' element={<CreateRoom />} />
            <Route path='/kicked' element={<Kicked />} />
            <Route path='/disconnected' element={<Disconnected />} />
            <Route path='/rooms' element={<YourRooms />} />
            <Route path='/yourrooms' element={<Navigate to="/rooms" replace />} />
            <Route path='/terms' element={<Terms />} />
            <Route path='/privacy' element={<Privacy />} />
            <Route path='/about' element={<About />} />
            <Route path='/aboutcreator' element={<AboutCreator />} />

            <Route path='/comingsoon' element={<ComingSoon />} />

            <Route path='/gettingstarted' element={<GettingStarted />} />
            <Route path='/recents' element={<Navigate to="/rooms" replace />} />
            <Route path='/deleted' element={<Deleted />} />
            <Route path='/login' element={<Login />} />
            <Route path='/downloadhelp' element={<DownloadHelp />} />
            <Route path='/room-full' element={<RoomFull />} />
          </Routes>
        </div>
      </Router>
    </UserProvider>

  );
}

export default App;
